import addToCart from '../lib/addToCart';
import { closePopup } from '../utils/popupController';
import renderMinicart from '../lib/renderMinicart';
import { SELECTORS, CART } from '../utils/constants';
import updateCart from '../lib/updateCart';
import getCart from '../lib/getCart';
import updateCartCount from '../lib/updateCartCount';

const initAtcForm = (isPopup = false) => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.querySelector('[data-atc-id-input]').value;
    const quantity = form.elements['quantity'] ? +form.elements['quantity'].value : 1;

    const sellingPlanEl = form.elements['selling_plan'];
    const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;

    return [variantId, quantity, sellingPlan];
  };

  const getAttributes = (form) => {
    const attributeInputs = form.querySelectorAll('input[name^="attributes["]');
    const attributes = {};

    attributeInputs.forEach((input) => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match) {
        const key = match[1];
        attributes[key] = input.value;
      }
    });
    return attributes;
  };

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity, sellingPlan] = getItem(evt.target);
      const attributes = getAttributes(evt.target);
      await addToCart(variantId, quantity, sellingPlan);
      if (attributes) {
        await updateCart(attributes);
      }
      await renderMinicart();
      if (isPopup) closePopup();
      window.theme.minicart?.open();
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    form.addEventListener('submit', addVariantToCart);
  });

  // Rebuy injects .rbr-bap-new-footer after page load and replaces our submit button on bundle
  // products. Its click never fires form submit, so use delegation and poll the cart until
  // the item count changes, then refresh the minicart.
  document.addEventListener('click', async (evt) => {
    if (!evt.target.closest('.rbr-bap-new-footer')) return;
    const before = await getCart();
    const beforeCount = before.item_count;
    let tries = 0;
    const poll = setInterval(async () => {
      tries++;
      const after = await getCart();
      if (after.item_count !== beforeCount || tries >= CART.BUNDLE_POLL_MAX_TRIES) {
        clearInterval(poll);
        updateCartCount(after.item_count);
        await renderMinicart();
        window.theme.minicart?.open();
      }
    }, CART.BUNDLE_POLL_INTERVAL_MS);
  });
};

export default initAtcForm;
